import React, { createContext, useContext, useState } from 'react';

const ProductDataContext = createContext();

export function useProductData() {
  return useContext(ProductDataContext);
}

export function ProductDataProvider({ children }) {
  const [productData, setProductData] = useState([]); 
const [isLoading, setIsLoading] = useState(false);
  return (
    <ProductDataContext.Provider value={{ productData, setProductData,setIsLoading,isLoading }}>
      {children}
    </ProductDataContext.Provider>
  );
}
